import StepCompleted from '../assets/icons/StepCompleted';

function getStatusData(isCreationRequested, isValidationRequested) {


    console.log(isCreationRequested, "see what is the status right now")

    return [
        {
            label: 'Draft',
            definition: ' Bounty details pending, complete draft to propose bounty creation',
        },
        ...(isCreationRequested ? [{
            label: 'Creation Requested',
            definition: 'Activity creation has been requested and is now awaiting backend verification. You will be notified once it is verified and goes live',
        }] : []),
        {
            label: 'Live',
            definition:
                'Bounty is deployed and live, ready to receive submissions. Bounty can be published (default) or unpublished',
        },
      
        {
            label: 'Unvalidated',
            definition: 'Bounty expired, validations are pending',
        },
        ...(isValidationRequested ? [{
            label: 'Validation Requested',
            definition: 'All activities have been scored. The backend team is now processing payments to the winners. You will be notified once the payment is completed.',
        }] : []),
        // {
        //     label: 'Validation Requested',
        //     definition: ' Proposal to validate the grading done on bounty submissions has been shared for voting ',
        // },
        {
            label: 'Completed',
            definition: 'Bounty has been executed, submissions paid and impact created',
        },
    ];

}

const data = [
    {
        label: 'Draft',
        definition: ' Bounty details pending, complete draft to propose bounty creation',
    },
    {
        label: 'Creation Requested',
        definition: 'Proposal to create the bounty has been shared for voting',
    },
    {
        label: 'Live',
        definition:
            'Bounty is deployed and live, ready to receive submissions. Bounty can be published (default) or unpublished',
    },

    {
        label: 'Unvalidated',
        definition: 'Bounty expired, validations are pending',
    },
    // {
    //     label: 'Validation Requested',
    //     definition: ' Proposal to validate the grading done on bounty submissions has been shared for voting ',
    // },
    {
        label: 'Completed',
        definition: 'Bounty has been executed, submissions paid and impact created',
    },
];
const dataFunding = [
    {
        label: 'Draft',
        definition: ' Bounty details pending, complete draft to propose bounty creation',
    },
    {
        label: 'Funding Requested',
        definition: 'Funding for bounty is ongoing on Impact Landscapes',
    },
    {
        label: 'Funding Failed',
        definition: 'Bounty did not receive funding target. You can choose to fund it yourself or delete the bounty',
    },
    {
        label: 'Deploy Ready',
        definition:
            'Bounty is deployed and live, ready to receive submissions. Bounty can be published (default) or unpublished',
    },

    {
        label: 'Live',
        definition:
            'Bounty is deployed and live, ready to receive submissions. Bounty can be published (default) or unpublished',
    },

    {
        label: 'Unvalidated',
        definition: 'Bounty expired, validations are pending',
    },

    {
        label: 'Completed',
        definition: 'Bounty has been executed, submissions paid and impact created',
    },
];

function getDataFunding(condition) {
    return [
        {
            label: 'Draft',
            definition: 'Bounty details pending, complete draft to propose bounty creation',
        },
        {
            label: 'Funding Requested',
            definition: 'Funding for bounty is ongoing on Impact Landscapes',
        },
        condition
            ? {
                label: 'Funding Failed',
                definition:
                    'Bounty did not receive funding target. You can choose to fund it yourself or delete the bounty',
            }
            : {
                label: 'Deploy Ready',
                definition:
                    'Bounty is deployed and live, ready to receive submissions. Bounty can be published (default) or unpublished',
            },
        {
            label: 'Live',
            definition:
                'Bounty is deployed and live, ready to receive submissions. Bounty can be published (default) or unpublished',
        },
        {
            label: 'Unvalidated',
            definition: 'Bounty expired, validations are pending',
        },
        {
            label: 'Completed',
            definition: 'Bounty has been executed, submissions paid and impact created',
        },
    ];
}

const Stepper = ({ rounded, className, bg, textColor, textClassName, text, borderColor, active, requestedFunding, isCreationRequested, isValidationRequested }) => {
    return (
        <ol class="relative  text-gray-500  text-textSecondary border-s border-gray-200 ">
            {(requestedFunding ? getDataFunding(active === 'Funding Failed') : getStatusData(isCreationRequested, isValidationRequested)).map((status, index) => {
                const isActive = active === status.label;
                const activeIndex = (requestedFunding ? getDataFunding(active === 'Funding Failed') : getStatusData(isCreationRequested, isValidationRequested)).findIndex(
                    (item) => item.label === active
                );
                return (
                    <li key={status.label} className="mb-6 last:mb-4 first:mt-1 ms-6">
                        <span
                            className={`absolute  flex ${activeIndex === index
                                ? ` ${borderColor} font-semibold  ${textColor}  `
                                : 'ring-borderColor font-medium text-textPrimary '
                                }   items-center  justify-center w-8 h-8 bg-grayBgNormal rounded-full -start-4 ring-1  `}
                        >
                            {activeIndex <= index ? index + 1 : <StepCompleted fillColor="#737373" />}
                        </span>

                        <p
                            className={`font-medium text-sm pt-1 leading-normal ${isActive ? textColor : 'text-[#A1A1AA'
                                } `}
                        >
                            <span
                                className={` text-sm  ${isActive ? ` underline  underline-offset-4  font-semibold  ` : ''
                                    } `}
                            >
                                {' '}
                                {status.label}
                                {isActive && ':'}
                            </span>
                            {isActive && <span className="text-sm"> {status.definition}</span>}
                        </p>
                    </li>
                );
            })}
        </ol>
    );
};

export default Stepper;
